import { GroupInvitePage } from '../c/Game';
export default GroupInvitePage;



// WEBPACK FOOTER //
// ./src/p/GroupInvitePage.js